<template>
  <modal-2 ref="select_plan" sheet-class="ct-sheet" :hideFooter="true">
    <template #header>
      <div style="display:flex; align-items:center; gap:10px;">
        <i class="fas fa-project-diagram" style="font-size:20px; color:#3c8dbc;"></i>
        <span style="font-size:16px; font-weight:600;">เลือกแผนงาน (Project Planning)</span>
      </div>
    </template>
    <template #body>
      <div class="row">
        <div class="col-md-12">
          <!-- Info banner -->
          <div class="callout callout-info" style="margin-bottom:14px; padding:8px 14px;">
            <i class="fas fa-info-circle"></i>
            <span style="margin-left:6px;">กรุณาเลือกแผนงานที่ต้องการผูกกับงานนี้ หรือดับเบิลคลิกที่แถวเพื่อยืนยันทันที</span>
          </div>

          <!-- Empty state -->
          <div v-if="list_ppn.length === 0" class="text-center" style="padding:30px 0; color:#999;">
            <i class="fas fa-folder-open" style="font-size:36px; margin-bottom:10px; display:block;"></i>
            <span>ไม่พบแผนงานที่สามารถเลือกได้</span>
          </div>

          <!-- Plan list as cards -->
          <div v-else class="sp-grid-wrap">
            <div class="sp-grid">
              <div
                v-for="(x, idx) in list_ppn"
                :key="x.plan_code"
                class="sp-card"
                :class="{ 'is-selected': selectedPlan && selectedPlan.plan_code === x.plan_code }"
                :title="x.planname"
                @click="$emit('update:selectedPlan', x)"
                @dblclick="DBgetApiPPN(x, idx)"
              >
                <div class="sp-card-top">
                  <span class="sp-card-ic"><i class="fas fa-tasks"></i></span>
                  <span class="sp-radio">
                    <i v-if="selectedPlan && selectedPlan.plan_code === x.plan_code" class="fas fa-check"></i>
                  </span>
                </div>
                <div class="sp-card-name">{{ x.planname || '(ไม่มีชื่อแผน)' }}</div>
                <div class="sp-card-code"><i class="fas fa-tag"></i>{{ x.plan_code }}</div>
                <div class="sp-card-hint"><i class="fas fa-mouse-pointer"></i> {{ ui.erp_double_click || 'ดับเบิลคลิก' }}เพื่อเลือก</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer actions -->
      <div style="display:flex; justify-content:flex-end; align-items:center; gap:8px; margin-top:16px; padding-top:12px; border-top:1px solid #eee;">
        <span v-if="selectedPlan" style="font-size:12px; color:#555; margin-right:auto;">
          <i class="fas fa-check-circle" style="color:#3c8dbc;"></i>
          {{ ui.erp_select || 'เลือก' }}: <strong>{{ selectedPlan.planname }}</strong>
        </span>
        <button type="button" class="btn btn-default btn-sm" @click="$refs.select_plan.closeModal()">
          <i class="fas fa-times"></i> {{ ui.cancel || 'ยกเลิก' }}
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          :disabled="!selectedPlan"
          @click.prevent="getApiPPN()"
          :style="{ opacity: selectedPlan ? 1 : 0.5 }"
        >
          <i class="fas fa-check"></i> ยืนยันการเลือก
        </button>
      </div>
    </template>
  </modal-2>
</template>

<script type="text/javascript">
  export default {
    props: {
      list_ppn: Array,
      selectedPlan: Object,
      DBgetApiPPN: Function,
      getApiPPN: Function,
    },
    data() {
      return {
        ui: window.ui,
      }
    },
    methods: {
      openModal() {
        this.$refs.select_plan.openModal()
      },
      closeModal() {
        this.$refs.select_plan.closeModal()
      },
      setSize(size) {
        this.$refs.select_plan.setSize(size)
      },
    },
  }
</script>

<style scoped>
  .sp-grid-wrap {
    max-height: 420px;
    overflow-y: auto;
    padding: 2px 4px 2px 2px;
  }
  .sp-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }
  .sp-card {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
    padding: 12px 14px;
    border: 1px solid #dde3ea;
    border-radius: 8px;
    background: #fafbfc;
    cursor: pointer;
    user-select: none;
    transition: border-color .15s, background-color .15s, box-shadow .15s;
  }
  .sp-card:hover {
    border-color: #9fc6e0;
    background: #fff;
    box-shadow: 0 2px 8px rgba(60,141,188,0.12);
  }
  .sp-card.is-selected {
    border-color: #3c8dbc;
    background: #eaf4fb;
    box-shadow: 0 0 0 1px #3c8dbc inset;
  }
  .sp-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2px;
  }
  .sp-card-ic {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: #3c8dbc;
    color: #fff;
    font-size: 14px;
  }
  .sp-radio {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #bbb;
    background: #fff;
    color: #fff;
    font-size: 10px;
  }
  .sp-card.is-selected .sp-radio {
    border-color: #3c8dbc;
    background: #3c8dbc;
  }
  .sp-card-name {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    line-height: 1.35;
    min-height: 2.7em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
  }
  .sp-card-code {
    font-size: 11px;
    color: #888;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .sp-card-code i {
    margin-right: 4px;
  }
  .sp-card-hint {
    margin-top: 2px;
    padding-top: 6px;
    border-top: 1px dashed #e3e8ee;
    font-size: 10px;
    color: #aaa;
  }

  @media (max-width: 991px) {
    .sp-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  @media (max-width: 575px) {
    .sp-grid {
      grid-template-columns: minmax(0, 1fr);
    }
  }
</style>
